import React from 'react'

const Footer = () => {
  return (
    <footer className='bg-slate-200 font-inter'>
     <div className='container mx-auto p-4'>
     <p className='text-center font-bold bg-gradient-to-b from-[#1FA2FF] via-[#12D8FA] to-[#A6FFCB] text-transparent bg-clip-text'>Code With Piyush</p>
     </div>
    </footer>
  )
}

export default Footer